import { useSelector } from 'react-redux';

export const useIsWorking = (key) => {
  const working = useSelector((store) => store.app.working);
  return working.some((item) => item.name === key);
};
